import CleanLinkButton from '../../../../../components/CleanLinkButton/CleanLinkButton';
import PaddedBox from '../../../../../components/PaddedBox/PaddedBox';
import Paragraph from '../../../../../components/Paragraph/Paragraph';
import Row from '../../../../../components/Row/Row';
import SVG from '../../../../../components/SVG/SVG';

import logo from './graphics/logo.svg?raw';

import styles from './Footer.module.css';

const Footer = () => {
    return (
        <PaddedBox horizontal="center" className={styles.Root}>
            <CleanLinkButton
                href="https://www.lets-book.com"
                target="_blank"
                disableInertia
            >
                <Row vertical="middle" space="small">
                    <Paragraph lineHeight="small" className={styles.Label}>
                        Powered by
                    </Paragraph>
                    <SVG
                        className={styles.Logo}
                        src={logo}
                        fillWithCurrentColor
                    />
                </Row>
            </CleanLinkButton>
        </PaddedBox>
    );
};

export default Footer;
